<template>
  <div class="app-thumbnail" :class="{ 'has-error': hasError }">
    <img 
      v-if="imageUrl && !hasError"
      :src="imageUrl" 
      :alt="alt"
      @error="handleImageError"
      @load="handleImageLoad"
      class="app-thumbnail-image"
      :class="imageClass"
    />
    <div v-else class="app-thumbnail-fallback" :class="fallbackClass">
      <div class="fallback-icon">
        <i :class="fallbackIcon"></i>
      </div>
      <span v-if="showFallbackText" class="fallback-text">{{ fallbackText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppThumbnail',
  props: {
    imageUrl: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ''
    },
    fallbackIcon: {
      type: String,
      default: 'icon-app-default'
    },
    fallbackText: {
      type: String,
      default: 'App'
    },
    showFallbackText: {
      type: Boolean,
      default: false
    },
    imageClass: {
      type: String,
      default: ''
    },
    fallbackClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hasError: false
    }
  },
  methods: {
    handleImageError() {
      this.hasError = true
      this.$emit('error')
    },
    handleImageLoad() {
      this.hasError = false
      this.$emit('load')
    }
  },
  watch: {
    imageUrl(newUrl) {
      if (newUrl) {
        this.hasError = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-thumbnail {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: $N7;
  border-radius: 8px 8px 0 0;
  
  &.has-error {
    .app-thumbnail-image {
      display: none;
    }
  }
}

.app-thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  border-radius: 8px 8px 0 0;
  
  &:hover {
    transform: scale(1.05);
  }
}

.app-thumbnail-fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: linear-gradient(135deg, $B5 0%, $N7 100%);
  border-radius: 8px 8px 0 0;
  
  .fallback-icon {
    font-size: 3rem;
    color: $Y1;
    margin-bottom: 0.5rem;
  }
  
  .fallback-text {
    font-size: 0.875rem;
    color: $N2;
    font-weight: 500;
  }
}
</style> 